import { TextField } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';

class Refracao extends XAPPComponent {

    render() {
        const { readOnly, formulario, onChange } = this.props;

        return (
            <div>
                <div className="flex flex-row">
                    <TextField
                        className="mb-24 w-1/4 mr-8"
                        label={"Esf."}
                        id={"OD_ESFERICO"}
                        name={"OD_ESFERICO"}
                        value={formulario.OD_ESFERICO}
                        onChange={onChange}
                        variant="outlined"
                        disabled={readOnly}
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="mb-24 w-1/4 mr-8"
                        label={"Cil."}
                        id={"OD_CILINDRO"}
                        name={"OD_CILINDRO"}
                        value={formulario.OD_CILINDRO}
                        onChange={onChange}
                        variant="outlined"
                        disabled={readOnly}
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="mb-24 w-1/4 mr-8"
                        label={"Eixo"}
                        id={"OD_EIXO"}
                        name={"OD_EIXO"}
                        value={formulario.OD_EIXO}
                        onChange={onChange}
                        variant="outlined"
                        disabled={readOnly}
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="mb-24 w-1/4 mr-8"
                        label={"Adição"}
                        id={"OD_ADICAO"}
                        name={"OD_ADICAO"}
                        value={formulario.OD_ADICAO}
                        onChange={onChange}
                        variant="outlined"
                        disabled={readOnly}
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </div>
                <div className="flex flex-row">
                    <TextField
                        className="mb-24 w-1/4 mr-8"
                        label={"Esf."}
                        id={"OE_ESFERICO"}
                        name={"OE_ESFERICO"}
                        value={formulario.OE_ESFERICO}
                        onChange={onChange}
                        variant="outlined"
                        disabled={readOnly}
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="mb-24 w-1/4 mr-8"
                        label={"Cil."}
                        id={"OE_CILINDRO"}
                        name={"OE_CILINDRO"}
                        value={formulario.OE_CILINDRO}
                        onChange={onChange}
                        variant="outlined"
                        disabled={readOnly}
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="mb-24 w-1/4 mr-8"
                        label={"Eixo"}
                        id={"OE_EIXO"}
                        name={"OE_EIXO"}
                        value={formulario.OE_EIXO}
                        onChange={onChange}
                        variant="outlined"
                        disabled={readOnly}
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="mb-24 w-1/4 mr-8"
                        label={"Adição"}
                        id={"OE_ADICAO"}
                        name={"OE_ADICAO"}
                        value={formulario.OE_ADICAO}
                        onChange={onChange}
                        variant="outlined"
                        disabled={readOnly}
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default Refracao;
